import React from "react";

import Layout from "../../../components/layout/layout";
import { PlansPage } from "../../../components/subscriptions/plans-page";

export default function SubscriptionPlans({ component, ...rest }) {
  return <Layout Component={PlansPage} controlsDisabled={true} {...rest} />;
}
